"use client";

import useDisableScrolling from "@/components/hooks/useDisableScrolling";
import { Button } from "@/components/ui/button";
import type { WebsiteWithConversionsLocationsImages } from "@/types/prisma";

export default function InactiveWebsitePrompt({ website }: { website: WebsiteWithConversionsLocationsImages }) {
  //Custom hook to disable scrolling
  useDisableScrolling();

  return (
    <div className="fixed top-0 z-50 flex h-full w-full items-center justify-center px-5">
      <div className="absolute left-0 right-0 top-0 h-full w-full select-none bg-ash-900 bg-opacity-50 backdrop-blur-2xl"></div>
      <div className="relative flex w-full max-w-7xl flex-col justify-between gap-12 overflow-hidden bg-ash-900 p-10 shadow-2xl sm:flex-row lg:mx-0 xl:gap-x-20">
        <div className="left-modal z-10 flex flex-col items-center justify-between gap-14 sm:items-baseline">
          <img src="/rebolt-branding/rebolt-full-white.png" alt="Rebolt Logo" className="h-6 w-fit sm:h-7" />
          <div className="left-description flex flex-col gap-3 text-center sm:max-w-sm sm:text-left items-center sm:items-start">
            <img src="/rebolt-branding/mark-white.png" alt="Rebolt Logo" className=" h-16 w-fit" />
            <h1 className="text-4xl font-semibold leading-none tracking-tight text-ash-100 sm:text-5xl">
              This site is no longer active!
            </h1>
            <p className="text-base text-ash-400">
              If you are the owner, you must reactive this site for it to be published again
            </p>
          </div>
        </div>
        <div className="right-modal z-10 flex flex-col items-center gap-3 text-center sm:items-end sm:justify-end">
          <a href={`https://rebolthq.com`}>
            <Button className="group flex items-center gap-2 bg-mint-100 px-2 py-4 text-base font-semibold text-mint-100 shadow-md transition-all duration-300 hover:bg-mint-800">
              <div className="h-2 w-2 rounded-full bg-mint-800 group-hover:bg-mint-100"></div>
              <span className="text-mint-800 group-hover:text-mint-100">Reactivate Site Now</span>
            </Button>
          </a>
          <span className="text-ash-500 sm:text-right">
            or contact us at{" "}
            <a
              href={`mailto:support@rebolthq.com?subject=Reactivate ${website.companyName ? encodeURIComponent(website.companyName) : ""} website request`}
              className="font-bold underline"
            >
              support@rebolthq.com
            </a>
          </span>
        </div>

        <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-0 w-full">
          <img src="/InactiveModalBG.svg" alt="Inactive Website BG" className=" h-full w-full object-cover" />
        </div>
      </div>
    </div>
  );
}
